export default __webpack_public_path__ + "static/box-3d1ea480ec3cec804dfc03aa3afb0a5e.png";